import { Button } from 'foundations-components/transitional/components/Button';
import { EditorToolbar } from 'foundations-components/transitional/components/EditorToolbar';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useState } from 'react';
import { useDraftSettings, useHasChanges, useResetDraftSettings } from '../../settings/store/slice/sectionSettingsActions';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { ConfirmationModal } from './ConfirmationModal';
import { useSaveCardSectionSettings } from '../../api/useSaveCardSectionSettings';
import { showFailureAlert, showSuccessAlert } from '../../utils/successFailureAlerts';
import { useIsAdminView } from '../../providers/settings/CardSettingsPanelProvider';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavigationBar = ({
  onClose
}) => {
  const isAdminView = useIsAdminView();
  const draftSettings = useDraftSettings();
  const resetDraftSettings = useResetDraftSettings();
  const hasChanges = useHasChanges();
  const {
    saveCardSectionSettings,
    loading: isSaveInProgress
  } = useSaveCardSectionSettings();
  const handleSave = useCallback(() => {
    // nothing to save in draft so we don't need to hit the BE to save and can simply close
    if (!hasChanges) {
      onClose();
      return;
    }
    saveCardSectionSettings({
      updatedSettings: draftSettings
    }).then(() => {
      showSuccessAlert();
      onClose();
    }).catch(() => {
      showFailureAlert();
    });
  }, [saveCardSectionSettings, draftSettings, onClose, hasChanges]);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const handleCloseConfirmationModal = useCallback(() => {
    setIsConfirmationModalOpen(false);
  }, []);
  const handleClose = useCallback(() => {
    if (hasChanges) {
      setIsConfirmationModalOpen(true);
    } else {
      resetDraftSettings();
      onClose();
    }
  }, [resetDraftSettings, onClose, hasChanges]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EditorToolbar, {
      startSlot: /*#__PURE__*/_jsx(_Fragment, {}),
      titleText: /*#__PURE__*/_jsx("span", {
        children: isAdminView ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoardCard.settings.editor.adminTitle"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoardCard.settings.editor.userTitle"
        })
      }),
      endSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-test-id": "board-card-settings-editor-exit-button",
          onClick: handleClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "crmObjectBoardCard.settings.editor.exit"
          })
        }), /*#__PURE__*/_jsx(LoadingButton, {
          use: "primary",
          "data-test-id": "board-card-settings-editor-save-button",
          onClick: handleSave,
          loading: isSaveInProgress,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "crmObjectBoardCard.settings.editor.save"
          })
        })]
      })
    }), isConfirmationModalOpen && /*#__PURE__*/_jsx(ConfirmationModal, {
      onConfirm: onClose,
      onReject: handleCloseConfirmationModal
    })]
  });
};
export default NavigationBar;